import Layer, { DrawLayerType, I_LayerRenderOptions } from "erayic-com-pack/component/NewMap/NewMapLayer/Layer";
import TownEndBayJsonData from "/public/assets/json/townAndBay.json";
import { RenderLayerLevel } from "erayic-com-pack/component/NewMap/NewMapBean";
import * as turf from '@turf/turf';

/** 海湾图层 */
export class TwonBayLayerLayer extends Layer {
    layerID?: string | undefined = "";
    layerSource = "";
    layerName = "";
    originalData: Array<{ [key: string]: any; }> = [];
    renderLayerList: Array<I_LayerRenderOptions> = [];
    timer = "";
    title = "";
    constructor(lineColor: string, color: string) {
        super([], "TwonBayLayerLayer", "");
        this.layerID = "TwonBayLayerLayer";
        this.layerName = "TwonBayLayerLayer";
        let symbolSourceData: { [key: string]: any } = {
            type: "geojson",
            data: {
                type: "FeatureCollection",
                features: []
            },
        };
        
        TownEndBayJsonData.features.forEach((item: any) => {
            let temp = turf.point([item.properties.lon, item.properties.lat]);
            temp.properties = item.properties;
            temp.properties!.ShowName = item.properties.name_x1;
            symbolSourceData.data.features.push(temp);
        });
        this.renderLayerList.push({
            layerName: "fill",
            drawLayerType: DrawLayerType.Fill,
            renderLayerLevel: RenderLayerLevel.surfaceLayer,
            properties: {
                type: 'fill',
                paint: {
                    "fill-color": 'rgba(0,0,0,0)', 
                },
            },
            source: {
                type: "geojson",
                data: TownEndBayJsonData
            }
        });
        this.renderLayerList.push({
            layerName: "line",
            drawLayerType: DrawLayerType.Line,
            renderLayerLevel: RenderLayerLevel.lineLayer,
            properties: {
                type: "line",
                paint: {
                    "line-color": lineColor ?? '#000', //线的颜色
                    "line-width": ["coalesce", ["get", "LineWidth"], 0.8], //线的宽度
                    "line-dasharray": [2, 1],
                },
            },
            source: {
                type: "geojson",
                data: TownEndBayJsonData
            }
        });
        this.renderLayerList.push({
            layerName: 'symbol',
            drawLayerType: DrawLayerType.Symbol,
            renderLayerLevel: RenderLayerLevel.pointLayer,
            properties: {
                type: "symbol",
                layout: { 
                    'text-field': ["coalesce", ["get", "ShowName"], ''],//文本内容
                    "text-size": 13,   //文本字体大小
                },
                paint: {
                  "icon-opacity": ["case", ["boolean", ["feature-state", "hover"], false], 0.8, 1],
                  "text-color": ["coalesce", ["get", "TextColor"], '#333'],//文字颜色
                  "text-halo-color": "#FFF", 
                  "text-halo-width": 1
                },
                minzoom: 9,
            },
            source: symbolSourceData as mapboxgl.AnySourceData
        });
        
    };
}
